var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRightRegularFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1092px",
    height: "1080px",
    viewBox: "0 0 1092 1080",
    enableBackground: "new 0 0 1092 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#94A3B8",
    d: "M737.531,511.313c15.862,15.862,15.862,41.513,0,57.206l-270,270.169c-15.862,15.862-41.513,15.862-57.206,0 c-15.694-15.862-15.863-41.513,0-57.206l241.313-241.313L410.325,298.856c-15.863-15.863-15.863-41.513,0-57.207 c15.862-15.694,41.513-15.862,57.206,0l270,270V511.313z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightRegularFull);
export default __webpack_public_path__ + "static/media/angle-right-regular-full.9c1b7edebb663e7740e2cfded7aeb820.svg";
export { ForwardRef as ReactComponent };